import type { ALMockPaper } from '@/pages/alevel/mock-exams/page';

interface Props {
  paper: ALMockPaper;
}

export default function ALMockPaperCard({ paper }: Props) {
  return (
    <div className="bg-white rounded-xl border border-slate-100 overflow-hidden hover:border-emerald-200 transition-colors group">
      <div className="px-5 py-4 bg-slate-50 border-b border-slate-100">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-slate-800 text-white">{paper.board}</span>
          <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-slate-100 text-slate-600">{paper.level}</span>
        </div>
        <p className="text-xs font-semibold text-slate-400">{paper.paper} · {paper.set}</p>
        <h3 className="text-sm font-bold text-slate-800 mt-1">{paper.title}</h3>
      </div>
      <div className="px-5 py-4">
        <div className="flex items-center gap-4 text-xs text-slate-500 mb-4">
          <span className="flex items-center gap-1"><i className="ri-time-line"></i>{paper.duration}</span>
          <span className="flex items-center gap-1"><i className="ri-award-line"></i>{paper.marks} marks</span>
          <span className="flex items-center gap-1"><i className="ri-download-line"></i>{paper.downloads.toLocaleString()}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mb-4">
          {paper.topics.map((t) => (
            <span key={t} className="text-xs px-2 py-0.5 bg-slate-100 text-slate-600 rounded-full">{t}</span>
          ))}
        </div>
        <div className="flex items-center gap-1 mb-4">
          {[1, 2, 3, 4, 5].map((star) => (
            <i key={star} className={`ri-star-fill text-xs ${star <= Math.round(paper.rating) ? 'text-amber-400' : 'text-slate-200'}`}></i>
          ))}
          <span className="text-xs text-slate-400 ml-1">{paper.rating}</span>
        </div>
        <div className="flex gap-2">
          <button className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-download-line text-xs"></i>Download Paper
          </button>
          {paper.hasMarkScheme && (
            <button className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg border border-slate-200 text-slate-600 text-xs font-semibold hover:bg-slate-50 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-check-line text-xs"></i>Mark Scheme
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
